import React from 'react';
import { useCurrentUser } from '../../common/withUser';
import DropdownItem from "../DropdownItem";
import { useMutation } from "@apollo/client/react";
import { gql } from "@/lib/generated/gql-codegen";

const CommentsListUpdateMutation = gql(`
  mutation updateCommentRetractCommentDropdownItem($selector: SelectorInput!, $data: UpdateCommentDataInput!) {
    updateComment(selector: $selector, data: $data) {
      data {
        ...CommentsList
      }
    }
  }
`);

const RetractCommentDropdownItem = ({comment}: {comment: CommentsList}) => {
  const currentUser = useCurrentUser();
  const [updateComment] = useMutation(CommentsListUpdateMutation);

  const handleRetract = () => {
    void updateComment({
      variables: {
        selector: { _id: comment._id },
        data: { retracted: true }
      }
    });
  }

  const handleUnretract = () => {
    void updateComment({
      variables: {
        selector: { _id: comment._id },
        data: { retracted: false }
      }
    });
  }

  if (!currentUser || comment.userId !== currentUser._id || comment.draft) {
    return null;
  }
  if (comment.retracted) {
    return (
      <DropdownItem
        title={"Unretract Comment"}
        onClick={handleUnretract}
        tooltip="Comment will be un-crossed-out, indicating you endorse it again."
      />
    );
  }

  return (
    <DropdownItem
      title={"Retract Comment"}
      onClick={handleRetract}
      tooltip="Comment will become crossed out, indicating you no longer endorse it."
    />
  );
}

export default RetractCommentDropdownItem;


